import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";
import { useI18n } from "../i18n/I18nProvider";
import { Loading } from "../components/common/States";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const { t } = useI18n();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api.post("/auth/session", { session_id: sid })
      .then(({ data }) => {
        setUser(data);
        navigate(location.pathname || "/dashboard", { replace: true, state: { user: data } });
      })
      .catch(() => navigate("/login?error=1", { replace: true }));
  }, [location, navigate, setUser]);

  return <Loading label={t("auth.processing")} />;
}
